import { render, staticRenderFns } from "./CreatePublicationBasedAdFormat.vue?vue&type=template&id=9e4fea90&"
import script from "./CreatePublicationBasedAdFormat.vue?vue&type=script&lang=js&"
export * from "./CreatePublicationBasedAdFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports